module.exports = __webpack_public_path__ + "static/media/icon_search.9d1b486c.svg";